import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DetailIcon from '@mui/icons-material/Details';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';

function UserIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const { isAuthenticated, companyId, branchId, userId, logout, token, permissions } = useAuth();

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);
  const hasCreateAdministrationPermission = permissions.includes('Create Administration');
  const hasEditAdministrationPermission = permissions.includes('Edit Administration');
  const hasDeleteAdministrationPermission = permissions.includes('Delete Administration');
  useEffect(() => {
    fetchtableData();
  }, []);


  const fetchtableData = async () => {

    fetchData('UserApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching User Details:', error);
      });


  };



  const handleDelete = async () => {
    deleteData('UserApi', `${deleteItemId}`, token)
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
        setDeleteItemId(null); // Reset the item ID
        setConfirmDialogOpen(false); // Close the dialog
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });

  };

  const handleActivate = (itemId) => {
    activateData('UserApi', `${itemId}`, token)
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
      })
      .catch((error) => {
        // Handle errors for the activation request
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto">
      <div className='w-full mb-2 flex'>
        <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor'>User</h5>
        {/* {hasCreateAdministrationPermission && ( */}
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/userCreate"
          className="linkcolor"
          style={{ marginLeft: '8px' }}
        >
          CREATE NEW
        </Button>
        {/* )} */}

      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#0B5345' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '3%' }}>Sl.No</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }} style={{ width: '230px' }}>First Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }} style={{ width: '230px' }}>Last Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }} style={{ width: '230px' }}>User Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }} style={{ width: '180px' }}>Contact Number</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }} style={{ width: '180px' }}>Email</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
              {data.map((item, index) => (
                <TableRow key={item.Id} className={item.IsActive ? '' : 'inactiveRow'}>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px', width: '3%' }}>{index + 1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px' }}>{item.FirstName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px' }}>{item.LastName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px' }}>{item.UserName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px' }}>{item.ContactNumber}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px' }}>{item.Email}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', fontSize: '14px' }}>

                    <Link to={`/userDetail/${item.ID}`}>
                      <IconButton>
                        <DetailIcon style={{ color: 'darksalmon' }} />
                      </IconButton>
                    </Link>

                    {hasEditAdministrationPermission && (
                      <Link to={`/userEdit/${item.ID}`}>
                        <IconButton color="primary">
                          <EditIcon />
                        </IconButton>
                      </Link>
                    )}

                    {hasDeleteAdministrationPermission && (
                      <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.ID) : handleActivate(item.ID))} color="error">
                        {item.IsActive ? <DeleteIcon /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                      </IconButton>
                    )}

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>



            </Dialog>


          </Table>
        </TableContainer>
      </div>
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>

  );
}

export default UserIndex;

